import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Accuwaregray"
});
const _hoisted_1 = {
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_174_82950)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.3045 6.96818L9.61908 23.3102L24.7997 14.5456L10.3045 6.96818Z"></path><path opacity="0.55" fill-rule="evenodd" clip-rule="evenodd" d="M13.4607 12.5008L4.20191 13.9933L9.61568 23.3703L19.0728 22.1926L13.4607 12.5008Z"></path><path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M13.4756 12.4995L19.3974 5.2273L24.7981 14.5442L19.0712 22.1915L13.4756 12.4995Z"></path><path opacity="0.346587" fill-rule="evenodd" clip-rule="evenodd" d="M13.4979 12.4844L19.4263 5.22365L10.3448 7.02307L4.24573 13.9883L13.4979 12.4844Z"></path></g><defs><clipPath id="clip0_174_82950"><rect width="25" height="25" fill="white" transform="translate(2.68628 2)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var Accuwaregray = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Accuwaregray as default };
